/**
 * System Lizard - Modulation LFO & Utilities
 * Provides dual modulation sources (Sine/Triangle/Square LFO) for Eurorack patch routing.
 */

export class LFOEngine {
  constructor(audioCtx) {
    this.ctx = audioCtx;
    this.rate = 1.5; // Hz
    this.depth = 0.5;
    this.type = 'sine';
    this.osc = null;
    this.gain = null;
  }

  init(ctx) {
    this.ctx = ctx;
    this.osc = this.ctx.createOscillator();
    this.gain = this.ctx.createGain();

    this.osc.type = this.type;
    this.osc.frequency.value = this.rate;
    this.gain.gain.value = this.depth;

    this.osc.connect(this.gain);
    this.osc.start();
  }

  setRate(hz) {
    this.rate = hz;
    if (this.osc) {
      this.osc.frequency.setTargetAtTime(hz, this.ctx.currentTime, 0.02);
    }
  }

  setDepth(d) {
    this.depth = d;
    if (this.gain) {
      this.gain.gain.setTargetAtTime(d, this.ctx.currentTime, 0.02);
    }
  }

  setType(t) {
    this.type = t;
    if (this.osc) {
      this.osc.type = t;
    }
  }
}
